enum OCCUPATION {
  student = 'student',
  workingProfessional = 'working professional',
  other = 'other',
  unknown = 'unknown',
}

export { OCCUPATION };
